module.exports = __webpack_public_path__ + "img/PortalBandung.47f48408.png";